// Players views
import Players from '@/views/Players.vue';
import PlayersList from '@/views/Players/PlayersList.vue';

import Player from '@/views/Players/Player.vue';
import PlayerInfo from '@/views/Players/components/Player/PlayerInfo.vue';
import PlayerLast from '@/views/Players/components/Player/PlayerLast.vue';
import PlayerCrm from '@/views/Players/components/Player/PlayerCrm.vue';

export default [
  {
    path: '/players',
    component: Players,
    meta: {
      requiresAuth: true,
      view: 'players',
    },
    children: [
      {
        path: 'list',
        component: PlayersList,
        name: 'players.list',
        meta: {
          view: 'playersList',
        },
      },
      {
        path: ':id',
        component: Player,
        name: 'players.item',
        children: [
          {
            path: 'info',
            component: PlayerInfo,
            name: 'players.item.info',
            meta: {
              view: 'info',
            },
          },
          {
            path: 'last-operations',
            component: PlayerLast,
            name: 'players.item.last',
            meta: {
              view: 'last',
            },
          },
          {
            path: 'crm',
            component: PlayerCrm,
            name: 'players.item.crm',
            meta: {
              view: 'crm',
            },
          },
        ],
      },

      {
        path: '',
        name: 'players.empty',
        redirect: {
          name: 'players.list',
        },
      },
      {
        path: ':catchAll(.*)',
        name: 'players.catch-all',
        redirect: {
          name: 'players.list',
        },
      },
    ],
  },
];
